<template>
  <div class="modal">
    <div class="wrap">
      <img class="close" :src="CloseIcon" @click="handleClose" />
      <p class="title">每日首次兑换获得</p>
      <p class="prize">碎片{{prize}}</p>
      <img :src="ReceiveIcon" class="receive" @click="gotoPrize" />
    </div>
  </div>
</template>

<script>
const CloseIcon = require("../../../assets/icon-close-round.png");
const ReceiveIcon = require("../../../assets/icon-prize-receive.png");

export default {
  props: ["prize"],
  data() {
    return {
      CloseIcon,
      ReceiveIcon
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    gotoPrize() {
      var url = process.env.lotteryLoginUrl;
      location.href = url;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.modal {
  p {
    margin: 0;
  }
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .wrap {
    position: relative;
    width: 80vw;
    height: 78.5vw;
    background: url("../../../assets/prize-modal-bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .close {
      width: 8vw;
      height: 8vw;
      position: absolute;
      right: 2vw;
      top: -12vw;
    }
    .title {
      color: #f3912d;
      font-size: 5vw;
      margin-top: 8vw;
      font-weight: 600;
      text-align: center;
    }
    .prize {
      text-align: center;
      color: #f94049;
      font-size: 5vw;
      font-weight: 600;
      margin-top: 5vw;
    }
    .receive {
      height: 13vw;
      display: block;
      margin: 0 auto;
      margin-top: 36vw;
    }
  }
}

.bounce-enter-active {
  animation: bounceIn 1s 0.2s ease both;
}

.bounce-leave-active {
  animation: bounceOut 1s 0.2s ease both;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bounceOut {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    opacity: 0;
    transform: scale(0.3);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Modal/PrizeModal.vue